import { useEffect } from "react";

// Draws a red dot in the corner of the favicon and prefixes the page title
// with a (•) marker whenever there are unread items.
const useFaviconBadge = (count = 0) => {
  useEffect(() => {
    const hasUnread = count > 0;
    const head = document.head;

    // Cache the original favicon + title once so we can restore them
    if (!window.__originalFavicon) {
      const existing = document.querySelector("link[rel*='icon']");
      window.__originalFavicon = existing?.href || "/favicon.ico";
    }
    if (!window.__originalTitle) {
      window.__originalTitle = document.title.replace(/^•\s*/, "");
    }

    const setIcon = (href) => {
      const links = document.querySelectorAll("link[rel*='icon']");
      links.forEach((l) => l.parentNode && l.parentNode.removeChild(l));
      const link = document.createElement("link");
      link.rel = "icon";
      link.type = "image/png";
      link.href = href;
      head.appendChild(link);
    };

    const drawBadged = (sourceUrl) => {
      const img = new Image();
      img.crossOrigin = "anonymous";
      img.onload = () => {
        const size = 64;
        const canvas = document.createElement("canvas");
        canvas.width = size;
        canvas.height = size;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, size, size);

        // Red badge dot (top-right)
        const r = 14;
        const cx = size - r - 2;
        const cy = r + 2;
        ctx.beginPath();
        ctx.arc(cx, cy, r, 0, Math.PI * 2);
        ctx.fillStyle = "#EF4444";
        ctx.fill();
        ctx.lineWidth = 3;
        ctx.strokeStyle = "#FFFFFF";
        ctx.stroke();

        if (count <= 9) {
          ctx.fillStyle = "#FFFFFF";
          ctx.font = "bold 18px Arial, sans-serif";
          ctx.textAlign = "center";
          ctx.textBaseline = "middle";
          ctx.fillText(String(count), cx, cy + 1);
        } else {
          ctx.fillStyle = "#FFFFFF";
          ctx.font = "bold 14px Arial, sans-serif";
          ctx.textAlign = "center";
          ctx.textBaseline = "middle";
          ctx.fillText("9+", cx, cy + 1);
        }

        try {
          setIcon(canvas.toDataURL("image/png"));
        } catch {
          // CORS-tainted canvas — fall back to plain dot
          drawDotOnly();
        }
      };
      img.onerror = () => drawDotOnly();
      img.src = sourceUrl;
    };

    const drawDotOnly = () => {
      const size = 64;
      const canvas = document.createElement("canvas");
      canvas.width = size;
      canvas.height = size;
      const ctx = canvas.getContext("2d");
      ctx.fillStyle = "#1a73e8";
      ctx.fillRect(0, 0, size, size);
      ctx.beginPath();
      ctx.arc(size - 16, 16, 14, 0, Math.PI * 2);
      ctx.fillStyle = "#EF4444";
      ctx.fill();
      ctx.lineWidth = 3;
      ctx.strokeStyle = "#FFFFFF";
      ctx.stroke();
      setIcon(canvas.toDataURL("image/png"));
    };

    if (hasUnread) {
      drawBadged(window.__originalFavicon);
      const title = window.__originalTitle;
      document.title = `(${count > 9 ? "9+" : count}) ${title}`;
    } else {
      setIcon(window.__originalFavicon);
      document.title = window.__originalTitle;
    }
  }, [count]);
};

export default useFaviconBadge;
